import { itemsUrl } from './resources.js';
import common from './common.js';
import store from '../store/index.js'

async function getItemsByRestaurant() {
    let restaurantid = store.state.restaurants.currentRestaurant.restaurantId;
    let url = `${itemsUrl}/getbyrestaurant/${restaurantid}`;
    let data;
    await common.getDataWithToken(url)
                .then(response => {
                    data = response.items });
    return data;
}

async function getItemsByRestaurantId(id) {
    let restaurantid = id;
    let url = `${itemsUrl}/getbyrestaurant/${restaurantid}`;
    let data;
    await common.getDataWithToken(url)
                .then(response => {
                    data = response.items });
    return data;
}

async function createItem(data) {
    let itemurl = `${itemsUrl}`;
    return await common.postData(itemurl, data);          
}

async function updateItem(data) {
    let url = `${itemsUrl}/${data.itemId}`;
    await common.putData(url, data);
}

async function deleteItem(itemId) {
    let url = `${itemsUrl}/${itemId}`;
    await common.deleteData(url);
}

export default {
    name: 'itemsService',
    getItemsByRestaurant,
    getItemsByRestaurantId,
    createItem,
    updateItem,
    deleteItem
} 